import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "leitner-details",
  class: "see-more"
}
const _hoisted_2 = { class: "see-more-toggle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_firecracker_header = _resolveComponent("firecracker-header")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_leitner_systems_flow = _resolveComponent("leitner-systems-flow")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_leitner_single_box = _resolveComponent("leitner-single-box")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_firecracker_header, {
        "header-title": "My Flashcards",
        "content-id": "leitner-boxes",
        "menu-id": "leitner-boxes-menu"
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        id: "leitner-boxes"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "display-flex ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                sizeXs: "12",
                sizeSm: "12",
                sizeMd: "10",
                sizeLg: "8",
                sizeXl: "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card, { class: "margin-top-bottom-unset" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_subtitle, null, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                              _createTextVNode(" Remembering new vocabulary can be challenging, especially over time. The Leitner System makes it easier by helping you review words at the right intervals. ", -1)
                            ]))]),
                            _: 1
                          }),
                          _withDirectives(_createElementVNode("div", _hoisted_1, [
                            _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top" }, {
                              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createTextVNode(" The Leitner System was developed by Sebastian Leitner, a German journalist. It uses a technique called spaced repetition, where you review words at increasing intervals to help you remember them for longer. ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_leitner_systems_flow),
                            _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top" }, {
                              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode(" The Leitner System uses five boxes to organise your flashcards based on how well you remember them. ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top" }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode(" Start by placing a new word in Box 1. Review it according to the schedule shown for each box. ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top" }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode(" If you remember a word, move it to the next box. If you forget it, move it back to the previous box. Words in Box 1 stay there until you remember them correctly. ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top" }, {
                              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createTextVNode(" As you move through the boxes, the time between reviews increases. This helps you focus more on difficult words while reviewing familiar ones less often. ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_subtitle, { class: "ion-padding-top" }, {
                              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createTextVNode(" Once a word reaches Box 5, you've mastered it! You can still review it whenever you like. ", -1)
                              ]))]),
                              _: 1
                            })
                          ], 512), [
                            [_vShow, !_ctx.seeLess]
                          ]),
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_ion_button, {
                              fill: "clear",
                              color: "primary",
                              "aria-expanded": !_ctx.seeLess,
                              "aria-controls": "leitner-details",
                              onClick: _ctx.toggle
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.seeLess ? 'Learn More' : 'See Less'), 1)
                              ]),
                              _: 1
                            }, 8, ["aria-expanded", "onClick"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "display-flex ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                sizeXs: "6",
                sizeSm: "4",
                sizeMd: "3",
                sizeLg: "3",
                sizeXl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_leitner_single_box, {
                    box: 1,
                    count: _ctx.count[1],
                    error: _ctx.error[1]
                  }, null, 8, ["count", "error"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                sizeXs: "6",
                sizeSm: "4",
                sizeMd: "3",
                sizeLg: "3",
                sizeXl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_leitner_single_box, {
                    box: 2,
                    count: _ctx.count[2],
                    error: _ctx.error[2]
                  }, null, 8, ["count", "error"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                sizeXs: "6",
                sizeSm: "4",
                sizeMd: "3",
                sizeLg: "3",
                sizeXl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_leitner_single_box, {
                    box: 3,
                    count: _ctx.count[3],
                    error: _ctx.error[3]
                  }, null, 8, ["count", "error"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                sizeXs: "6",
                sizeSm: "4",
                sizeMd: "3",
                sizeLg: "3",
                sizeXl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_leitner_single_box, {
                    box: 4,
                    count: _ctx.count[4],
                    error: _ctx.error[4]
                  }, null, 8, ["count", "error"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                sizeXs: "6",
                sizeSm: "4",
                sizeMd: "3",
                sizeLg: "3",
                sizeXl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_leitner_single_box, {
                    box: 5,
                    count: _ctx.count[5],
                    error: _ctx.error[5]
                  }, null, 8, ["count", "error"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}